import ContactPage from "./ContactPage";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";

// react-snap prerenders pages in a headless browser on localhost. If the
// reCAPTCHA provider renders during that pass, its localhost-initialized
// script/badge gets baked into the static HTML and shows a stale
// "Localhost is not supported" error on the live domain. react-snap sets
// navigator.userAgent to "ReactSnap", so we skip the provider during
// prerendering and let reCAPTCHA load fresh, client-side, on the real domain.
const isPrerendering =
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

const ContactPageWrapped = (props) => {
  if (isPrerendering) {
    return <ContactPage {...props} />;
  }

  return <GoogleReCaptchaProvider
    reCaptchaKey={"6LdAQ1otAAAAAHH-Zxxa7pqutvWRIaoPPkbwrqMs"}
    scriptProps={{
      async: false, // optional, default to false,
      defer: false, // optional, default to false
      appendTo: 'head', // optional, default to "head", can be "head" or "body",
      nonce: undefined // optional, default undefined
    }}
  >
    <ContactPage {...props} />
  </GoogleReCaptchaProvider>
}

export default ContactPageWrapped;
